import { makeStyles } from '@material-ui/core';
import { Button } from 'components/Base';
import BoxWrapper from 'components/Base/BoxWrapper/BoxWrapper';
import Fields from 'components/Fields';
import { Field, Formik, FormikProps } from 'formik';
import React from 'react';

type UnsupportedFundDecisionProps = {
  close: Function;
  setReplicateFundFromInvalid: Function;
  fundName: string;
  fundValue: string;
  oldFundId: number;
  removeInvalidFund: Function;
};

const options = [
  {
    label: 'Replicate',
    value: 'replicate',
    description:
      'If you replicate the fund you will be able to use it later in a model portfolio'
  },
  {
    label: 'Move it to trash',
    value: 'delete',
    description: 'Exclude it from Existing Portfolio'
  }
];
const useStyles = makeStyles({
  box: {
    width: '20rem',
    height: '16rem',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  btnContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  }
});

const UnsupportedFundDecision = ({
  close,
  setReplicateFundFromInvalid,
  fundName,
  fundValue,
  oldFundId,
  removeInvalidFund
}: UnsupportedFundDecisionProps) => {
  const classes = useStyles();
  const onSubmit = (values: any) => {
    setReplicateFundFromInvalid({ isVisble: true, initialValues: {} });
    close();
    if (values.decision === 'replicate') {
      setReplicateFundFromInvalid({
        isVisible: true,
        initialValues: {
          name: `Replicate - ${fundName}`,
          fund_value: fundValue,
          oldFundId
        }
      });
    } else {
      removeInvalidFund(oldFundId);
    }
  };
  return (
    <Formik
      enableReinitialize
      initialValues={{
        decision: ''
      }}
      onSubmit={(values, { resetForm }) => {
        onSubmit(values);
        resetForm();
      }}
    >
      {({ handleSubmit }: FormikProps<any>) => {
        return (
          <BoxWrapper title="Unsupported Fund" closeModal={() => close()}>
            <form onSubmit={handleSubmit} className={classes.box}>
              <Field
                label="Decision"
                name="decision"
                component={Fields.v2.Radio}
                options={options}
              />
              <div className={classes.btnContainer}>
                <Button type="submit">Confirm</Button>
              </div>
            </form>
          </BoxWrapper>
        );
      }}
    </Formik>
  );
};

export default UnsupportedFundDecision;
